import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Button } from '@unified-checkout/design-system';
import { ChevronLeft, ChevronRight } from '@unified-checkout/design-system/icons/index';
import { googleTagManagerInitializer } from '@app/dashboard/utils/googleTagManager';
import { useLangStore } from '@app/dashboard/store/lang';
import { OUTER_ROUTES } from '@app/dashboard/routes/outer-routes';
import FormIntro from '@app/dashboard/components/outer_layout/FormIntro';
import FormIntroHeading from '@app/dashboard/components/outer_layout/FormIntroHeading';
import LoginForm from './steps/LoginForm';
import OtpStep from './steps/OtpStep';

const STEPS = {
  LOGIN: 1,
  OTP: 2,
}

const Login = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  // googleTagManagerInitializer();
  const { lang } = useLangStore();

  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(STEPS.LOGIN);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otpToken, setOtpToken] = useState('');

  const redirectToRegister = () => {
    navigate(OUTER_ROUTES.REGISTER);
  };

  const formSubTitles = {
    [STEPS.LOGIN]: '',
    [STEPS.OTP]: t('form.enterTheCode').replace('{{phoneNum}}', phoneNumber),
  };

  return (
    <FormIntro
      heading={
        <FormIntroHeading
          lead={t('outerLayout.welcomeBackHeadingPrefix')}
          emphasis={t('outerLayout.welcomeHeadingBrand')}
        />
      }
      formLegend={t('outerLayout.form.login.signIn')}
      subtitle={formSubTitles[currentStep]}
      backBtnProps={
        currentStep === STEPS.OTP ?
          {
            size: 'md',
            variant: 'outlined',
            leadingIcon: lang === 'en' ? ChevronLeft : ChevronRight,
            onClickHandler: () => setCurrentStep(STEPS.LOGIN)
          }
          :
          undefined
      }
    >
      {
        currentStep === STEPS.LOGIN &&
        <>
          <LoginForm
            setPhoneNumber={setPhoneNumber}
            loading={loading}
            setLoading={setLoading}
            setCurrentStep={setCurrentStep}
            STEPS={STEPS}
            redirectToRegister={redirectToRegister}
            setOtpToken={setOtpToken}
          />
        </>
      }
      {
        currentStep === STEPS.OTP &&
        <>
          <OtpStep
            loading={loading}
            setLoading={setLoading}
            redirectToRegister={redirectToRegister}
            otpToken={otpToken}
          />
        </>
      }
    </FormIntro>
  )
}

export default Login;